import auth from "../../middlewares/auth";
export const otherRoutes = [
    {
        path: '/roles',
        component: () => import(/* webpackChunkName: "chat_settings" */ '../../views/settings/roles/Index'),
        name: 'roles',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['ticket-category-manage']
        }
    },
    {
        path: '/ticket-category',
        component: () => import(/* webpackChunkName: "chat_settings" */ '../../views/settings/ticket_category/Index'),
        name: 'ticket_category',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['ticket-category-manage']
        }
    },
];